module.exports = __webpack_public_path__ + "static/img/webdesign-02.062b4ed2.jpg";